import { httpApi as httpNodeApi } from '@nucleus-care/nucleuscare-backend-client';

type GetCallLogParams = {
  callLogId: string;
};

type UpdateCallLogParams = {
  callLogId: string;
  notes: string;
  userId: string;
};

export type CallLogParticipant = {
  ID: string;
  Description: string;
  HasVideoStats: boolean;
};

export type CallLogDetails = {
  CallLogID: string;
  DateString?: string;
  EndTime?: number;
  HasNotes: boolean;

  ID?: string;
  PatientID?: string;
  RequestID?: string;
  InProgress: boolean;
  Notes?: string;
  NotesUserID?: string;
  Participants: CallLogParticipant[];

  RequestEscalated: string;

  RequestNumber: number;
  RequestTime: string;
  RequestType: string;
  StartTime: number;
  Status?: string;
  TimeString?: string;
  WasAnswered?: boolean;
  clientRoleName?: string;
  patientTimezone?: string;
};

export const CallLogApi = {
  getCallLog: async (params: GetCallLogParams) => {
    return httpNodeApi.get<{
      ok: boolean;
      counter: number;
      callLogData: CallLogDetails;
    }>(`call-log/${params.callLogId}`);
  },
  updateCallLog: async (params: UpdateCallLogParams) => {
    return httpNodeApi.put(`call-log/${params.callLogId}/update-notes`, {
      UserID: params.userId,
      Notes: params.notes,
    });
  },
};
